import React from "react";
import injectSheet from "react-jss";

const BeautifulSpinner = (props) => {
  const { classes } = props;

  return (
    <div className={classes.spinWrapper}>
      <div className="spinner" />
    </div>
  );
};
const styles = (theme) => ({
  spinWrapper: {
    width: (props) => props.width + "px",
    height: (props) => props.width + "px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    "& .spinner": {
      position: "absolute",
      height: (props) => props.width / 2 + "px",
      width: (props) => props.width / 2 + "px",
      border: (props) =>
        props.width < 50
          ? "1px solid transparent"
          : props.width < 100
          ? "2px solid transparent"
          : "3px solid transparent",
      borderTopColor: theme.themeColor + "!important",
      borderRadius: "50%",
      animation: "$spin 2s linear infinite",
      "&:before, &:after": {
        content: "''",
        position: "absolute",
        borderRadius: "50%",
        border: (props) =>
          props.width < 50
            ? "1px solid transparent"
            : props.width < 100
            ? "2px solid transparent"
            : "3px solid transparent",
      },
      "&:before": {
        borderTopColor: theme.menuDarkColor + "!important",
        top: (props) => "-" + props.width / 10 + "px",
        left: (props) => "-" + props.width / 10 + "px",
        right: (props) => "-" + props.width / 10 + "px",
        bottom: (props) => "-" + props.width / 10 + "px",
        animation: "$spin 3s linear infinite",
      },
      "&:after": {
        borderTopColor: theme.themeHoverColor + "!important",
        top: (props) => props.width / 10 / 2 + "px",
        left: (props) => props.width / 10 / 2 + "px",
        right: (props) => props.width / 10 / 2 + "px",
        bottom: (props) => props.width / 10 / 2 + "px",
        animation: "$spin 4s linear infinite",
      },
    },
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
});

export default injectSheet(styles)(BeautifulSpinner);
